import { DatagridConfigurable, List, SelectInput } from 'react-admin';
import { AIPromptTagsCommandPanel } from './AIPromptTagsCommandPanel';
import {
  renderExportColumns,
  renderGridColumns,
} from '@/components/ConfigurableColumns';
import { columns } from './AIPromptsTagsColumns';
import { ModernListActions } from '@/components/DefaultListActions';
import { genericCSVExporter } from '@/util/genericCSVExporter';

export const entityTypes = {
  journalEntries: 'Patient - Journal Entries',
  therapistSessionNotes: 'Therapist - Session Notes',
  therapistLiveNotes: 'Therapist - Live Notes',
  therapistHomework: 'Therapist - Homework',
};

const statusChoices = [
  { id: 'enabled', name: 'Enabled' },
  { id: 'disabled', name: 'Disabled' },
];

export const entityTypesChoices = Object.entries(entityTypes).map(
  ([id, name]) => ({
    id,
    name,
  }),
);

const filters = [
  <SelectInput
    alwaysOn
    key="entityType"
    label="Entity Type"
    source="entityType"
    choices={entityTypesChoices}
  />,
  <SelectInput
    alwaysOn
    key="status"
    label="Status"
    source="status"
    choices={statusChoices}
  />,
];

export const AIPromptTagsList = () => (
  <List
    resource="aiPromptTags"
    filters={filters}
    actions={
      <ModernListActions
        exporter={documentsCsvExporter}
        collectionName="aiPromptTags"
        createButton
      />
    }
    sort={{ field: 'entityName', order: 'ASC' }}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      expand={AIPromptTagsCommandPanel}
    >
      {renderGridColumns(columns)}
    </DatagridConfigurable>
  </List>
);

export const documentsCsvExporter = genericCSVExporter(
  'aiPromptTags',
  renderExportColumns(columns),
);
